import {computed, inject, Injectable, signal} from '@angular/core';
import {injectQuery} from '@tanstack/angular-query-experimental';
import {lastValueFrom} from 'rxjs';
import {InvoiceService, InvoiceStateId, PaymentMethod} from '../../../../api';
import {QueryKey} from '../../../constants/query-key';
import {FinancesPeriodStore} from './finances-period.store';

@Injectable()
export class InvoiceStoreService {
  private invoiceService = inject(InvoiceService);
  private periodStore = inject(FinancesPeriodStore);

  filterParams = signal<InvoiceFilter>({
    searchTerm: null,
    customerIds: null,
    legalEntityIds: null,
    stateNames: null,
  });

  private get _hasDates() {
    const {startDate, endDate} = this.periodStore.period();
    return startDate != null && endDate != null;
  }

  invoicesQuery = injectQuery(() => ({
    queryKey: [QueryKey.INVOICES, this.periodStore.period().startDate, this.periodStore.period().endDate, this.filterParams()],
    queryFn: () => lastValueFrom(this.invoiceService.getInvoices(
      this.periodStore.period().startDate,
      this.periodStore.period().endDate,
      this.filterParams().customerIds ?? [],
      this.filterParams().stateNames ?? [],
      this.filterParams().legalEntityIds ?? [],
      this.filterParams().paymentMethods ?? [],
      this.filterParams().searchTerm,
    )),
    enabled: this._hasDates,
  }));

  isLoading = computed(() => this.invoicesQuery.isLoading());
  invoices = computed(() => this.invoicesQuery.data()?.invoices ?? []);
}

export interface InvoiceFilter {
  searchTerm: string | null;
  customerIds: number[] | null;
  legalEntityIds: number[] | null;
  stateNames: InvoiceStateId[] | null;
  paymentMethods?: PaymentMethod[] | null;
}
